<template>
  <div class="album-list">
    <b-loading :active="loading"></b-loading>
    <div v-if="!loading" class="container">
      <div class="filters is-hidden-touch">
        <div class="level">
          <div class="level-left">
            <base-button
              @click="setSelectedCategory(null)"
              :variant="selectedCategory === null ? 'primary' : 'secondary'"
              class="level-item"
            >
              All
            </base-button>
            <div
              v-for="(filter, index) in filters"
              :key="`cat-${index}`"
              class="level-item"
            >
              <base-button
                @click="setSelectedCategory(filter)"
                :variant="filter === selectedCategory ? 'primary' : 'secondary'"
              >
                {{ filter }}
              </base-button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div
          v-for="album in filteredAlbums"
          :key="`album-${album.id}`"
          class="column is-one-third-tablet is-one-quarter-widescreen"
        >
          <router-link
            :to="{ name: 'album-detail', params: { slug: album.slug } }"
          >
            <album-item :album="album" />
          </router-link>
        </div>
      </div>
      <div class="columns is-centered has-text-centered">
        <div class="column">
          <div v-show="!albums.length">
            No albums to show
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlbumItem from "@/components/AlbumItem";
import categories from "@/constants/categories";

export default {
  name: "AlbumList",

  components: {
    AlbumItem
  },

  data() {
    return {
      loading: true
    };
  },

  computed: {
    albums() {
      return this.$store.state.albums;
    },
    filteredAlbums() {
      return this.albums.filter(item =>
        this.selectedCategory === null
          ? this.isInString(item.artist, this.searchTerm)
          : item.decade_bfilter === this.selectedCategory &&
            this.isInString(item.artist, this.searchTerm)
      );
    },
    filters() {
      return this.$store.state.filters;
    },
    searchTerm() {
      return this.$store.state.searchTerm;
    },
    selectedCategory() {
      return this.$store.state.selectedCategory;
    }
  },

  beforeMount() {
    if (!this.albums.length) {
      this.getAlbums();
    } else {
      this.loading = false;
    }
  },

  methods: {
    isInString(a, b) {
      return b.toLowerCase()
        ? a.toLowerCase().search(b.toLowerCase()) > -1
        : true;
    },
    setSelectedCategory(category) {
      this.$store.commit("setSelectedCategory", category);
    },

    async getAlbums() {
      this.loading = true;
      await this.$store.dispatch("getAlbums");
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.album-list {
  height: 100%;
}

.filters {
  padding-bottom: 30px;
}
</style>
